import React, { useState } from "react";
import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { doc, setDoc } from "firebase/firestore";

const Signup = () => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const userCred = await createUserWithEmailAndPassword(auth, email, password);
      await setDoc(doc(db, "users", userCred.user.uid), {
        uid: userCred.user.uid,
        email: userCred.user.email,
        firstName,
        lastName
      });
      navigate("/chat");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={{ textAlign: "center", paddingTop: "100px" }}>
      <h2>Sign Up</h2>
      <form onSubmit={handleSignup}>
        <input value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First Name" /><br /><br />
        <input value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Last Name" /><br /><br />
        <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" /><br /><br />
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" /><br /><br />
        <button type="submit">Sign Up</button>
      </form>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default Signup;